// BẢN ĐỒ GIAO DIỆN — HỢP ĐỒNG DÙNG CHUNG với phiên "Bản đồ giao diện" (GĐ2: Super Boss quản lý/phát bản đồ).
// ĐỔI HÌNH DẠNG các kiểu dưới đây thì GHI .claude/PROJECT_LOG.md (phiên kia đọc/ghi cùng hợp đồng này).
//
// Bản đồ = các THAO TÁC đã kiểm thật trên từng mạng. AI lắp kịch bản CHỈ từ thao tác có trong bản đồ (chọn thao tác + điền tham số),
// không viết selector, không thêm bước đăng nhập. Phần thực thi của mỗi thao tác là một KhoiMau (yamlSteps + learned + params +
// chamPhuHop) y như thư viện khối Tự dựng. GĐ1 dùng BẢN ĐỒ v0 = THU_VIEN (src/shared/khoi-thu-vien.ts) + phần hiển thị ở đây.
// Server đọc bản đồ qua layBanDo() (server/src/ban-do-nguon.ts) — GĐ2 thay nguồn đó bằng bản lấy từ DB.
import { THU_VIEN } from "./khoi-thu-vien";
import type { KhoiMau, KhoiThamSo } from "./tu-dung";
import { thuTuCua, thuTuTuTimCua, type ThuTuThaoTac, type ThuTuTuTim } from "./so-do-thu-tu";
import { moTaThaoTac } from "./so-do-sua";
import { TS_CHO_DEN, TS_CHO_TU } from "./cho-giua-lan";
import { HIEN_THI_VIDEO, NHAN_VIDEO } from "./video-khoi"; // (06/10/2026) khối "Đăng video"
import { HIEN_THI_THEO_DOI, NHAN_THEO_DOI } from "./khoi-theo-doi"; // (07/10/2026) nhóm 1 xây kênh
import { HIEN_THI_XAY_KENH, NHAN_XAY_KENH } from "./khoi-xay-kenh"; // (07/10/2026) nhóm 2 xây kênh
import { HIEN_THI_SO_LIEU } from "./khoi-so-lieu"; // (07/10/2026) nhóm 3 xây kênh
import { HIEN_THI_TIN_NHAN, NHAN_TIN_NHAN } from "./khoi-tin-nhan"; // (07/10/2026) nhóm 4 xây kênh

export type RuiRo = "cao" | "thap";

export interface ThaoTacThamSo extends KhoiThamSo {
  nhan: string; // nhãn ngắn hiện trên sơ đồ ("Từ khoá", "Số bài"…)
}

export interface ThaoTac {
  ma: string; // = tên khối (KhoiMau.ten) — duy nhất trong một mạng
  tenNgan: string; // tên thẻ trên sơ đồ ("Tìm bài viết")
  moTa: string; // mô tả dài cho AI đọc (= KhoiMau.moTa)
  mauMoTa: string; // mẫu lời cho người dùng: {ten_tham_so} = giá trị; [ … ] = đoạn tuỳ chọn, chỉ hiện khi mọi tham số trong đó có giá trị
  bieuTuong: string; // một emoji
  thamSo: ThaoTacThamSo[];
  ruiRo: RuiRo; // SUY TỪ KHỐI (có bước risk: high) — người dùng không gỡ được trên sơ đồ
  khoi: KhoiMau; // phần thực thi
}

export interface NenTangBanDo {
  ma: string; // "facebook" | "tiktok" | "youtube" | "x" (GĐ2 có thể thêm)
  ten: string;
  url: string; // trang gốc (targets.web.url của kịch bản; {{goc}} trong khối)
  phienBan: string;
  ghiChu: string;
  thaoTac: ThaoTac[];
}

export interface BanDo {
  phienBan: string;
  nenTang: NenTangBanDo[];
}

// Bản công khai cho trang web: bỏ phần thực thi (selector, yamlSteps) — web chỉ cần tên/lời/tham số/rủi ro.
// (04/10/2026) + thuTu: cấu trúc khối RÚT GỌN (id bước, danh sách tạo/cần, là nghỉ) để trang kiểm LUẬT THỨ TỰ trước khi gửi bằng chính hàm
// của máy chủ (so-do-thu-tu.ts) — khe kéo-thả vi phạm hiện màu cấm, menu ⋯ / bảng thêm bước nói lý do. Không lộ selector/yamlSteps.
// thuTuTuTim (05/10/2026): cấu trúc biến thể tự tìm khi để trống địa chỉ — trang kiểm thứ tự theo ĐÚNG khối máy chủ sẽ lắp (so-do-thu-tu.ts mucThuTuHieuLuc).
export type ThaoTacCongKhai = Omit<ThaoTac, "khoi"> & { thuTu: ThuTuThaoTac; thuTuTuTim?: ThuTuTuTim };
export interface BanDoCongKhai { phienBan: string; nenTang: (Omit<NenTangBanDo, "thaoTac"> & { thaoTac: ThaoTacCongKhai[] })[] }

export const NHAN_THAM_SO: Record<string, string> = {
  tu_khoa: "Từ khoá",
  so_bai: "Số bài tối đa",
  so_video: "Số video tối đa",
  so_tra_loi: "Số bình luận trả lời tối đa",
  video_url: "Địa chỉ video",
  tai_khoan: "Tài khoản của mình",
  bai_url: "Địa chỉ bài",
  chu_binh_luan: "Chữ có trong bình luận",
  goc_nhin: "Góc nhìn của nick",
  nhom_url: "Địa chỉ nhóm",
  chu_de: "Chủ đề",
  so_nhom: "Số nhóm tối đa",
  thoi_gian_giay: "Thời gian lướt (giây)",
  so_bai_xem: "Số bài xem tối đa",
  so_thich: "Số bài thích tối đa",
  tu_khoa_thich: "Từ khoá bài để thích",
  // 06/10/2026 — chờ giữa các lần (src/shared/cho-giua-lan.ts) + cấu hình nhiều từ khoá (src/shared/tu-khoa-nhieu-dong.ts)
  cho_tu_giay: "Chờ giữa các lần: từ (giây)",
  cho_den_giay: "Chờ giữa các lần: đến (giây)",
  tu_khoa_cau_hinh: "Cấu hình nhiều từ khoá (số lượng, giờ chuyển, chế độ)",
  tu_giay: "Nghỉ từ (giây)",
  den_giay: "Đến (giây)",
  // như người (X / TikTok / YouTube, 2026-10-01)
  so_bai_doc: "Số bài lướt đọc",
  giay_doc: "Giây đọc mỗi bài",
  giay_xem: "Giây xem mỗi video",
  ti_le_thich: "Tỉ lệ thích (%)",
  giay_nghi: "Giây nghỉ",
  so_cau: "Số câu trả lời tối đa mỗi lượt",
  // Facebook 2026-10-03
  so_lan_xem_them: "Số lần bấm Xem thêm",
  ten_trang: "Tên Trang",
  noi_dung: "Nội dung bài",
  // 04/10/2026 — đăng nhóm tự chọn nhóm khi để trống địa chỉ
  tu_khoa_chon_nhom: "Từ khoá chọn nhóm",
  gian_cach_dang_ngay: "Giãn cách đăng cùng nhóm (ngày)",
  // 04/10/2026 — bình luận / trả lời kèm ảnh sản phẩm (src/shared/kem-anh.ts)
  kem_anh: "Kèm ảnh (khong / luon / ti_le)",
  tu_tra_loi_cau_hoi: "Tự trả lời câu hỏi kiểm duyệt (co / khong)",
  chi_bai_lien_quan: "Chỉ bình luận bài liên quan (co / khong)",
  ti_le_anh: "Tỉ lệ kèm ảnh (%)",
  khi_loi_anh: "Khi không đính được ảnh (chi_chu / bo_muc)",
  anh_chon: "Ảnh dùng (Kho ảnh)", // 05/10/2026 — tập ảnh chọn trong Kho ảnh (src/shared/kho-anh.ts)
  ...NHAN_VIDEO, // 06/10/2026 — cau_hinh_video (bước Đăng video)
  ...NHAN_THEO_DOI, // 07/10/2026 — theo dõi / đăng ký / tham gia / chia sẻ
  ...NHAN_XAY_KENH, // 07/10/2026 — đăng bài kênh / thả tim, ghim
  ...NHAN_TIN_NHAN, // 07/10/2026 — trả lời tin nhắn / sửa tiểu sử
  // 08/10/2026 — đợt B: ô tuỳ chọn theo bước (src/shared/tuy-chon-buoc.ts)
  toi_da_ngay: "Tối đa mỗi ngày",
  ti_le_nhac: "Tỉ lệ nhắc sản phẩm (%)",
  bat_buoc_ten: "Bắt buộc có tên sản phẩm (co / khong)",
  xem_tu_giay: "Xem/đọc trước khi gửi: từ (giây)",
  xem_den_giay: "Xem/đọc trước khi gửi: đến (giây)",
  tu_phut: "Lướt từ (phút)",
  den_phut: "Lướt đến (phút)",
  so_tu: "Số mục ít nhất",
  thich_tu: "Thích ít nhất",
  thich_den: "Thích nhiều nhất",
  mo_danh_cho_ban: "Mở tab Dành cho bạn (co / khong)",
};

interface HienThi { tenNgan: string; mauMoTa: string; bieuTuong: string }
// Phần hiển thị theo "mạng/thao tác". Thiếu mục → dùng mô tả khối (vẫn chạy được, chỉ kém dễ đọc).
const HIEN_THI: Record<string, HienThi> = {
  "facebook/tim_bai": { bieuTuong: "🔎", tenNgan: "Tìm bài viết", mauMoTa: "Tìm bài viết trên Facebook theo từ khoá “{tu_khoa}” và lấy danh sách bài" },
  "facebook/binh_luan_bai": { bieuTuong: "💬", tenNgan: "Bình luận các bài tìm được", mauMoTa: "Bình luận tối đa {so_bai} bài vừa tìm (bỏ bài quá ngắn, bài nhóm chưa tham gia, bài đã bình luận); AI soạn câu theo giọng điệu" },
  "facebook/dang_bai_nhom": { bieuTuong: "📝", tenNgan: "Đăng bài vào nhóm", mauMoTa: "Mở nhóm[ {nhom_url}][!nhom_url (không ghi địa chỉ: bot tự chọn một nhóm đã tham gia hợp chủ đề)] và đăng một bài AI soạn về “{chu_de}”" },
  "facebook/thich_binh_luan": { bieuTuong: "👍", tenNgan: "Thích một bình luận", mauMoTa: "Mở bài {bai_url} và bấm Thích bình luận có chữ “{chu_binh_luan}”" },
  "facebook/tra_loi_mot_binh_luan": { bieuTuong: "↩️", tenNgan: "Trả lời một bình luận", mauMoTa: "Mở bài {bai_url}, AI soạn câu trả lời cho bình luận có chữ “{chu_binh_luan}” rồi gửi" },
  "facebook/binh_luan_mot_bai": { bieuTuong: "💬", tenNgan: "Bình luận một bài", mauMoTa: "[Mở bài {bai_url}][!bai_url Tự tìm một bài mới trong nhóm đã tham gia hợp từ khoá (không ghi địa chỉ)] và bình luận một câu AI soạn[ với góc nhìn “{goc_nhin}”]" },
  "facebook/tim_nhom": { bieuTuong: "🔎", tenNgan: "Tìm nhóm", mauMoTa: "Tìm nhóm Facebook theo từ khoá “{tu_khoa}” và lấy danh sách nhóm (đã tham gia / chưa / đang chờ duyệt, số thành viên)" },
  "facebook/tham_gia_nhom": { bieuTuong: "🤝", tenNgan: "Tham gia nhóm", mauMoTa: "Xin tham gia tối đa {so_nhom} nhóm CHƯA tham gia vừa tìm (bỏ nhóm đã tham gia / đang chờ duyệt; nhóm có câu hỏi kiểm duyệt → AI tự trả lời rồi gửi, câu đòi thông tin cá nhân bắt buộc → cần người)" },
  "facebook/luot_bang_tin": { bieuTuong: "📜", tenNgan: "Lướt bảng tin", mauMoTa: "Lướt bảng tin[ nhóm {nhom_url}] khoảng {thoi_gian_giay} giây / tối đa {so_bai_xem} bài như người đọc, thích tối đa {so_thich} bài[ có “{tu_khoa_thich}”]" },
  "facebook/thich_bai": { bieuTuong: "👍", tenNgan: "Thích các bài", mauMoTa: "Thích tối đa {so_bai} bài trong danh sách vừa có (bỏ bài đã thích)" },
  "facebook/nghi": { bieuTuong: "⏸️", tenNgan: "Nghỉ", mauMoTa: "Nghỉ ngẫu nhiên {tu_giay}–{den_giay} giây như người dừng tay" },
  // FB 2026-10-03 (người dùng duyệt)
  "facebook/tra_loi_binh_luan_bai_minh": { bieuTuong: "💬", tenNgan: "Trả lời bình luận dưới bài của mình", mauMoTa: "Mở bài của mình[ {bai_url}] (không ghi địa chỉ = các bài mới nhất trên trang cá nhân[, tối đa {so_bai} bài]), bấm “Xem thêm”[ tối đa {so_lan_xem_them} lần], trả lời tối đa {so_tra_loi} bình luận của người khác cả lượt (bỏ bình luận của mình, bình luận đã trả lời, bình luận chỉ có ảnh/sticker); AI soạn câu theo giọng điệu" },
  "facebook/dang_bai_trang": { bieuTuong: "📣", tenNgan: "Đăng bài lên Trang", mauMoTa: "Chuyển sang Trang “{ten_trang}”, đăng một bài[ AI soạn về “{chu_de}”][ nội dung “{noi_dung}”] dưới TÊN TRANG (kiểm tên người đăng), rồi chuyển về hồ sơ cá nhân" },
  "tiktok/tim_video": { bieuTuong: "🔎", tenNgan: "Tìm video", mauMoTa: "Tìm video TikTok theo từ khoá “{tu_khoa}” và lấy danh sách video" },
  "tiktok/binh_luan": { bieuTuong: "💬", tenNgan: "Bình luận các video tìm được", mauMoTa: "Bình luận tối đa {so_video} video vừa tìm (bỏ video đã bình luận); AI soạn câu theo giọng điệu" },
  "tiktok/tra_loi_binh_luan": { bieuTuong: "↩️", tenNgan: "Trả lời bình luận dưới video", mauMoTa: "Mở video {video_url} và trả lời tối đa {so_tra_loi} bình luận của người khác[ (bỏ bình luận của “{tai_khoan}”)]" },
  "tiktok/tra_loi_mot_binh_luan": { bieuTuong: "↩️", tenNgan: "Trả lời một bình luận", mauMoTa: "Mở video {bai_url}, AI soạn câu trả lời cho bình luận có chữ “{chu_binh_luan}” rồi gửi" },
  "tiktok/binh_luan_mot_bai": { bieuTuong: "💬", tenNgan: "Bình luận một video", mauMoTa: "[Mở video {bai_url}][!bai_url Tự tìm một video hợp từ khoá (không ghi địa chỉ)] và bình luận một câu AI soạn[ với góc nhìn “{goc_nhin}”]" },
  "youtube/tim_video": { bieuTuong: "🔎", tenNgan: "Tìm video", mauMoTa: "Tìm video YouTube theo từ khoá “{tu_khoa}” và lấy danh sách video (bỏ playlist, quảng cáo, Shorts)" },
  "youtube/binh_luan": { bieuTuong: "💬", tenNgan: "Bình luận các video tìm được", mauMoTa: "Bình luận tối đa {so_video} video vừa tìm (bỏ video đã bình luận); AI soạn câu theo giọng điệu" },
  "youtube/tra_loi_binh_luan": { bieuTuong: "↩️", tenNgan: "Trả lời bình luận dưới video", mauMoTa: "Mở video {video_url} và trả lời tối đa {so_tra_loi} bình luận của người khác[ (bỏ bình luận của “{tai_khoan}”)]" },
  "youtube/thich_binh_luan": { bieuTuong: "👍", tenNgan: "Thích một bình luận", mauMoTa: "Mở video {bai_url} và bấm Thích bình luận có chữ “{chu_binh_luan}”" },
  "youtube/tra_loi_mot_binh_luan": { bieuTuong: "↩️", tenNgan: "Trả lời một bình luận", mauMoTa: "Mở video {bai_url}, AI soạn câu trả lời cho bình luận có chữ “{chu_binh_luan}” rồi gửi" },
  "youtube/binh_luan_mot_bai": { bieuTuong: "💬", tenNgan: "Bình luận một video", mauMoTa: "[Mở video {bai_url}][!bai_url Tự tìm một video hợp từ khoá (không ghi địa chỉ)] và bình luận một câu AI soạn[ với góc nhìn “{goc_nhin}”]" },
  "x/tim_bai": { bieuTuong: "🔎", tenNgan: "Tìm bài", mauMoTa: "Tìm bài mới nhất trên X theo từ khoá “{tu_khoa}” và lấy danh sách bài" },
  "x/tra_loi": { bieuTuong: "↩️", tenNgan: "Trả lời các bài tìm được", mauMoTa: "Trả lời tối đa {so_bai} bài vừa tìm (bỏ quảng cáo, bài đã trả lời[, bài của {tai_khoan}]); AI soạn câu ≤ 280 ký tự" },
  "x/dang_bai": { bieuTuong: "📝", tenNgan: "Đăng bài mới", mauMoTa: "Đăng một bài mới trên X do AI soạn về “{chu_de}” (≤ 280 ký tự)" },
  "x/thich_bai": { bieuTuong: "👍", tenNgan: "Thích một bài", mauMoTa: "Mở {bai_url} và bấm Thích bài/trả lời có chữ “{chu_binh_luan}”" },
  "x/tra_loi_mot_bai": { bieuTuong: "↩️", tenNgan: "Trả lời một bài", mauMoTa: "Mở {bai_url}, AI soạn câu trả lời cho bài có chữ “{chu_binh_luan}” rồi gửi" },
  "x/binh_luan_mot_bai": { bieuTuong: "💬", tenNgan: "Trả lời vào một bài", mauMoTa: "[Mở bài {bai_url}][!bai_url Tự tìm một bài mới nhất hợp từ khoá (không ghi địa chỉ)] và trả lời một câu AI soạn[ với góc nhìn “{goc_nhin}”]" },
  // ---- như người: X (2026-10-01) ----
  "x/luot_bang_tin": { bieuTuong: "📜", tenNgan: "Lướt bảng tin", mauMoTa: "Lướt đọc tối đa {so_bai_doc} bài đang hiện[, dừng {giay_doc} giây mỗi bài][, thích khoảng {ti_le_thich}% số bài] (bỏ quảng cáo)" },
  "x/nghi": { bieuTuong: "☕", tenNgan: "Nghỉ một lúc", mauMoTa: "Nghỉ[ {giay_nghi} giây][ — ngẫu nhiên {tu_giay}–{den_giay} giây (thay số giây cố định)] như người thật trước khi làm tiếp" },
  "x/dang_lai": { bieuTuong: "🔁", tenNgan: "Đăng lại một bài", mauMoTa: "[Mở {bai_url}][!bai_url Tự tìm một bài mới nhất hợp từ khoá (không ghi địa chỉ)] và Đăng lại (repost) bài đó" },
  "x/trich_dan": { bieuTuong: "❝", tenNgan: "Trích dẫn một bài", mauMoTa: "[Mở {bai_url}][!bai_url Tự tìm một bài mới nhất hợp từ khoá (không ghi địa chỉ)], AI đọc bài rồi soạn lời trích dẫn ≤ 280 ký tự[ với góc nhìn “{goc_nhin}”] và đăng" },
  // L-72 (2026-10-02)
  "x/tra_loi_phan_hoi": { bieuTuong: "💬", tenNgan: "Trả lời người trả lời bài của mình", mauMoTa: "Mở bài của mình[ {bai_url}] (không ghi địa chỉ = bài mới nhất của nick đang đăng nhập) và trả lời tối đa {so_tra_loi} người đã trả lời bài (bỏ trả lời của chính mình, người đã được đáp); AI soạn câu ≤ 280 ký tự" },
  // ---- như người: TikTok (2026-10-01) ----
  "tiktok/xem_video": { bieuTuong: "👀", tenNgan: "Xem một video", mauMoTa: "[Mở video {bai_url}][!bai_url Tự tìm một video hợp từ khoá (không ghi địa chỉ)] và xem[ {giay_xem} giây]" },
  "tiktok/thich_video": { bieuTuong: "❤️", tenNgan: "Thích một video", mauMoTa: "[Mở video {bai_url}][!bai_url Tự tìm một video hợp từ khoá (không ghi địa chỉ — đặt sau bước Xem để trống thì đúng video vừa xem)] và bấm Thích (nếu chưa thích)" },
  "tiktok/luot_video": { bieuTuong: "📺", tenNgan: "Lướt xem các video tìm được", mauMoTa: "Xem lần lượt tối đa {so_video} video vừa tìm[, mỗi video {giay_xem} giây][, thích khoảng {ti_le_thich}% số video]" },
  "tiktok/luot_de_xuat": { bieuTuong: "📱", tenNgan: "Lướt Dành cho bạn", mauMoTa: "Lướt trang Dành cho bạn: xem {so_video} video[, mỗi video {giay_xem} giây] (chỉ xem)" },
  "tiktok/nghi": { bieuTuong: "☕", tenNgan: "Nghỉ một lúc", mauMoTa: "Nghỉ[ {giay_nghi} giây][ — ngẫu nhiên {tu_giay}–{den_giay} giây (thay số giây cố định)] như người thật trước khi làm tiếp" },
  // ---- như người: YouTube (2026-10-01) ----
  "youtube/xem_video": { bieuTuong: "👀", tenNgan: "Xem một video", mauMoTa: "[Mở video {bai_url}][!bai_url Tự tìm một video hợp từ khoá (không ghi địa chỉ)] và ở lại xem[ {giay_xem} giây]" },
  "youtube/thich_video": { bieuTuong: "👍", tenNgan: "Thích một video", mauMoTa: "[Mở video {bai_url}][!bai_url Tự tìm một video hợp từ khoá (không ghi địa chỉ — đặt sau bước Xem để trống thì đúng video vừa xem)] và bấm Thích (nếu chưa thích)" },
  "youtube/luot_video": { bieuTuong: "📺", tenNgan: "Lướt xem các video tìm được", mauMoTa: "Xem lần lượt tối đa {so_video} video vừa tìm[, mỗi video {giay_xem} giây][, thích khoảng {ti_le_thich}% số video]" },
  "youtube/luot_shorts": { bieuTuong: "📱", tenNgan: "Lướt Shorts", mauMoTa: "Lướt Shorts: xem {so_video} Short[, mỗi Short {giay_xem} giây] (chỉ xem)" },
  "youtube/nghi": { bieuTuong: "☕", tenNgan: "Nghỉ một lúc", mauMoTa: "Nghỉ[ {giay_nghi} giây][ — ngẫu nhiên {tu_giay}–{den_giay} giây (thay số giây cố định)] như người thật trước khi làm tiếp" },
  // ---- 2026-10-03: trả lời bình luận dưới video của CHÍNH kênh mình; Reddit tìm rồi bình luận ----
  "youtube/tra_loi_binh_luan_kenh_minh": { bieuTuong: "🎙️", tenNgan: "Trả lời bình luận trên kênh của mình", mauMoTa: "Mở {so_video} video mới nhất của kênh mình và trả lời tối đa {so_cau} bình luận của người khác chưa được kênh phản hồi (bỏ bình luận của chính kênh); AI soạn câu như chủ kênh" },
  "tiktok/tra_loi_binh_luan_kenh_minh": { bieuTuong: "🎙️", tenNgan: "Trả lời bình luận trên video của mình", mauMoTa: "Mở {so_video} video mới nhất trên trang cá nhân của mình (bỏ video ghim) và trả lời tối đa {so_cau} bình luận của người khác chưa được mình phản hồi; AI soạn câu như chủ kênh" },
  "reddit/binh_luan_mot_bai": { bieuTuong: "💬", tenNgan: "Bình luận một bài", mauMoTa: "[Mở bài {bai_url}][!bai_url Tự tìm một bài mới hợp từ khoá (không ghi địa chỉ)] và bình luận một câu AI soạn đúng chủ đề[ với góc nhìn “{goc_nhin}”]" },
  ...HIEN_THI_VIDEO, // 06/10/2026 — Đăng video (Facebook / YouTube / TikTok)
  ...HIEN_THI_THEO_DOI, // 07/10/2026 — nhóm 1 xây kênh
  ...HIEN_THI_XAY_KENH, // 07/10/2026 — nhóm 2 xây kênh
  ...HIEN_THI_SO_LIEU, // 07/10/2026 — nhóm 3: đọc số liệu kênh
  ...HIEN_THI_TIN_NHAN, // 07/10/2026 — nhóm 4: trả lời tin nhắn / sửa tiểu sử
  "reddit/tim_roi_binh_luan": { bieuTuong: "💬", tenNgan: "Tìm bài rồi bình luận", mauMoTa: "Tìm bài Reddit mới theo từ khoá “{tu_khoa}” và bình luận tối đa {so_bai} bài còn mở (bỏ bài khoá/lưu trữ, bài của mình, bài đã bình luận); cộng đồng cấm quảng cáo thì câu không nhắc sản phẩm" },
};

export function ruiRoCuaKhoi(k: KhoiMau): RuiRo {
  return /^\s*risk:\s*high\s*$/m.test(k.yamlSteps) ? "cao" : "thap";
}

// Sao chép sâu dữ liệu thuần (khối là JSON thuần — xem KhoiMau).
const sao = <T>(v: T): T => JSON.parse(JSON.stringify(v)) as T;

// Dựng một ThaoTac (dạng công khai của GĐ1) từ KhoiMau + phần hiển thị theo "mạng/thao tác". GĐ2 dùng lại cho thao tác lưu trong DB.
export function thaoTacBanDo(nenTang: string, k0: KhoiMau, hienThi?: Partial<HienThi>): ThaoTac {
  // trangThu là ghi chú của thư viện (trang đã đo selector) — không thuộc phần thực thi: bản đồ v0 phải TRÙNG bản đồ đọc từ CSDL (dạng lưu không có trường này).
  const { trangThu: _trangThu, ...k } = sao(k0);
  // Ghi đè của Super chỉ có hiệu lực khi CÓ giá trị — `undefined` không được xoá phần hiển thị mặc định của GĐ1.
  const ghiDe = Object.fromEntries(Object.entries(hienThi ?? {}).filter(([, v]) => typeof v === "string" && v.trim() !== ""));
  const ht = { ...HIEN_THI[`${nenTang}/${k.ten}`], ...ghiDe } as Partial<HienThi>;
  return {
    ma: k.ten,
    tenNgan: ht.tenNgan ?? k.ten.replace(/_/g, " "),
    moTa: k.moTa,
    // (06/10/2026) "Chờ giữa các lần": đoạn tuỳ chọn, chỉ hiện trong lời bước khi người dùng đã điền cả hai ô.
    mauMoTa: (ht.mauMoTa ?? k.moTa) + (k.thamSo.some((t) => t.ten === TS_CHO_TU) ? `[; chờ ${"{"}${TS_CHO_TU}}–${"{"}${TS_CHO_DEN}} giây giữa các lần]` : ""),
    bieuTuong: ht.bieuTuong ?? "•",
    thamSo: k.thamSo.map((t) => ({ ...t, nhan: NHAN_THAM_SO[t.ten] ?? t.ten.replace(/_/g, " ") })),
    ruiRo: ruiRoCuaKhoi(k),
    khoi: k,
  };
}

export function banDoV0(): BanDo {
  return {
    phienBan: "v0",
    nenTang: THU_VIEN.map((tv) => ({
      ma: tv.ma,
      ten: tv.ten,
      url: tv.url,
      phienBan: "v0",
      ghiChu: tv.ghiChu,
      thaoTac: tv.khoi.map((k0) => thaoTacBanDo(tv.ma, k0)),
    })),
  };
}

export function timNenTang(banDo: BanDo, ma: string): NenTangBanDo | undefined {
  return banDo.nenTang.find((n) => n.ma === ma);
}

export function timThaoTac(banDo: BanDo, nenTang: string, ma: string): ThaoTac | undefined {
  return timNenTang(banDo, nenTang)?.thaoTac.find((t) => t.ma === ma);
}

export function banDoCongKhai(banDo: BanDo): BanDoCongKhai {
  return { phienBan: banDo.phienBan, nenTang: banDo.nenTang.map((n) => ({ ...n, thaoTac: n.thaoTac.map(({ khoi, ...t }) => ({ ...t, thamSo: t.thamSo.map((x) => ({ ...x })), thuTu: thuTuCua({ khoi }), ...(khoi.tuTim ? { thuTuTuTim: thuTuTuTimCua(khoi) } : {}) })) })) };
}

// Bản sao bản đồ với trang gốc khác cho vài mạng (kiểm thử trên trang giả).
export function doiGocBanDo(banDo: BanDo, goc: Record<string, string>): BanDo {
  const b = sao(banDo);
  for (const n of b.nenTang) if (goc[n.ma]) n.url = goc[n.ma]!;
  return b;
}

// Lời một thao tác với tham số cụ thể. Giữ nguyên chữ (web dựng bằng textContent nên ký tự đặc biệt không thành HTML).
// (04/10/2026) Định nghĩa ở so-do-sua.ts (nhẹ, trang web dùng để hiện lời bước vừa chèn NGAY, trước khi máy chủ trả lời) — một nguồn duy nhất.
export { moTaThaoTac };

// ===================== GĐ2 — DẠNG LƯU trong CSDL của Super (server/src/ban-do.ts) + giao thức bot + TẦNG GIAO DIỆN =====================
// Kiểu CÔNG KHAI ở trên (BanDo/NenTangBanDo/ThaoTac) là hợp đồng với GĐ1 — KHÔNG đổi. Phía Super lưu thao tác ở dạng phẳng ThaoTacLuu
// (có phiên bản, sửa bằng JSON dễ) và server đổi sang ThaoTac khi phát bản đồ cho AI/Boss: xem sangBanDo() / layBanDo() ở server/src/ban-do-nguon.ts.
export interface ThaoTacLuu {
  ma: string; // = KhoiMau.ten (slug)
  moTa: string;
  thamSo: KhoiThamSo[];
  ruiRo: RuiRo;
  yamlSteps: string;
  learned: Record<string, unknown>;
  params?: KhoiMau["params"];
  chamPhuHop?: KhoiMau["chamPhuHop"];
  tuTim?: KhoiMau["tuTim"]; // (05/10/2026) biến thể tự tìm khi để trống địa chỉ một bài/video — src/shared/tu-dung.ts BienTheTuTim
  phienBan?: number; // phiên bản của thao tác trong kho server
  // Tuỳ chọn: phần hiển thị cho người dùng trên sơ đồ (không có → lấy mặc định như banDoV0)
  tenNgan?: string;
  mauMoTa?: string;
  bieuTuong?: string;
}

export interface NenTangLuu { ma: string; ten: string; url: string; ghiChu?: string; thaoTac: ThaoTacLuu[] }
export interface BanDoLuu { phienBan: number; nenTang: NenTangLuu[] }

// Mức rủi ro suy từ bước YAML: có "risk: high" → cao.
export function ruiRoCua(yamlSteps: string): RuiRo {
  return /^\s*risk:\s*high\b/m.test(yamlSteps) ? "cao" : "thap";
}

export function thaoTacTuKhoi(k: KhoiMau): ThaoTacLuu {
  const t: ThaoTacLuu = { ma: k.ten, moTa: k.moTa, thamSo: k.thamSo, ruiRo: ruiRoCua(k.yamlSteps), yamlSteps: k.yamlSteps, learned: k.learned };
  if (k.params) t.params = k.params;
  if (k.chamPhuHop) t.chamPhuHop = k.chamPhuHop;
  if (k.tuTim) t.tuTim = k.tuTim;
  return t;
}

// Ngược lại: thao tác lưu → KhoiMau để lắp bằng sinhKichBan (tu-dung.ts).
export function khoiTuThaoTac(t: ThaoTacLuu): KhoiMau {
  const k: KhoiMau = { ten: t.ma, moTa: t.moTa, thamSo: t.thamSo, yamlSteps: t.yamlSteps, learned: t.learned };
  if (t.params) k.params = t.params;
  if (t.chamPhuHop) k.chamPhuHop = t.chamPhuHop;
  if (t.tuTim) k.tuTim = t.tuTim;
  return k;
}

// Dạng lưu → ThaoTac công khai của GĐ1 (phần hiển thị: ghi đè của Super nếu có, không thì mặc định theo mạng/thao tác).
export function sangThaoTac(nenTang: string, t: ThaoTacLuu): ThaoTac {
  return thaoTacBanDo(nenTang, khoiTuThaoTac(t), { tenNgan: t.tenNgan, mauMoTa: t.mauMoTa, bieuTuong: t.bieuTuong });
}

// Bản đồ lưu (số bản phát hành) → BanDo của GĐ1 (phienBan dạng chuỗi "v<số>").
export function sangBanDo(luu: BanDoLuu): BanDo {
  const pb = `v${luu.phienBan}`;
  return { phienBan: pb, nenTang: luu.nenTang.map((n) => ({ ma: n.ma, ten: n.ten, url: n.url, phienBan: pb, ghiChu: n.ghiChu ?? "", thaoTac: n.thaoTac.map((t) => sangThaoTac(n.ma, t)) })) };
}

// Id các bước "giao diện" của thao tác = khoá của learned (bước có selector/hành động đã học). Dùng để tra bước lỗi của bot → thao tác.
// Gồm cả BƯỚC CON của vòng lặp (learned[cha].con — xem gopDaHoc trong shared/tu-dung.ts): bot báo lỗi theo id bước con (vd thich_video_luot).
// Biến thể tự tìm (tuTim) là một BỘ bước khác của cùng thao tác — gọi riêng với learned của biến thể (server/src/ban-do.ts layChiMuc).
// (đợt B) phần đã học CHỈ mang ô tuỳ chọn theo bước (tuy-chon-buoc.ts — bước soạn / bước nghỉ: nhac_sp, khoang_nghi…) không phải bước giao diện.
const CHI_TUY_CHON = new Set(["han_ngay", "nhac_sp", "xem_truoc", "khoang_nghi", "lap_theo_gio", "so_muc", "chon_thich", "mo_truoc"]);
const laBuocTuyChon = (v: unknown): boolean => !!v && typeof v === "object" && !Array.isArray(v) && Object.keys(v).length > 0 && Object.keys(v).every((k) => CHI_TUY_CHON.has(k));
export function buocGiaoDien(t: Pick<ThaoTacLuu, "learned">): string[] {
  const out: string[] = [];
  for (const [k, v] of Object.entries(t.learned ?? {})) {
    if (!laBuocTuyChon(v)) out.push(k);
    const con = (v as { con?: unknown } | null)?.con;
    if (con && typeof con === "object" && !Array.isArray(con)) for (const [c, cv] of Object.entries(con)) if (!out.includes(c) && !laBuocTuyChon(cv)) out.push(c);
  }
  return out;
}

// Trạng thái đồng bộ bản đồ mà server báo cho bot (BotPolicy.banDo) — bot tự tải bằng token của mình.
export interface BanDoPolicy { so: number; hash: string; duongDan: string }

// ===================== TẦNG GIAO DIỆN (GĐ2, thêm sau khi người dùng làm rõ: "bản đồ giao diện các mạng xã hội để AI biết click vào đâu") =====================
// mạng → trang (tìm kiếm, bài viết, khu bình luận, soạn bài…) → phần tử bấm/gõ được, lấy từ tệp khảo sát của bot (ban-do-giao-dien-*.json).
// Thao tác (tầng trên) tham chiếu phần tử qua selector trong learned; khảo sát mới làm phần tử biến mất → thao tác dùng nó bị đánh dấu "nghi".
export type TrangThaiPhanTuGD = "con" | "mat" | "moi"; // so với lần khảo sát liền trước của cùng trang

export interface PhanTuGD {
  khoa: string; // ổn định giữa các lần khảo sát: hash(tag|vaiTro|nhãn chuẩn hoá|css|thuộc tính nhận dạng chung) — KHÔNG gồm toạ độ/số thứ tự
  tag: string;
  vaiTro: string | null;
  nhan: string; // chữ hiển thị (cắt ≤ 200 ký tự) hoặc aria-label/placeholder khi không có chữ
  css: string | null;
  thuocTinh: Record<string, string>; // data-e2e, data-testid, aria-label, id, placeholder, role… (giá trị riêng một người đã bị lọc khỏi khoá, vẫn giữ để xem)
  vung?: string;
  trangThai: TrangThaiPhanTuGD;
  thaoTac: { id: string; ma: string }[]; // thao tác đang dùng phần tử này
}

// khongTin (L-87 bổ sung): lần khảo sát MỚI NHẤT của trang không tin được (captcha / trang đăng nhập / không mở được đúng trang / phần tử tụt mạnh)
// → phần tử giữ trạng thái của lần tin được trước đó; luc/soPhanTu trong khongTin là của lần không tin được.
export interface TrangGD { nenTang: string; ma: string; ten: string; url: string; tieuDe: string; luc: string; soPhanTu: number; soMat: number; soMoi: number; khongTin?: { lyDo: string; luc: string; soPhanTu: number; soCu: number } }

export interface DoiGD { id: number; luc: string; nenTang: string; trang: string; loai: "mat" | "moi"; nhan: string; css: string | null; thaoTacAnhHuong: { id: string; ma: string }[] }

// API (chỉ Super) — server/src/ban-do-giao-dien.ts:
//  GET /api/ban-do/giao-dien                                → { nenTang: { ma, ten, soTrang, soPhanTu, capNhatLuc, soDoi }[] }
//  GET /api/ban-do/giao-dien/:nenTang                       → { nenTang, trang: TrangGD[] }
//  GET /api/ban-do/giao-dien/:nenTang/:trang?q=&tt=&trang=&co=  → { trang: TrangGD, phanTu: PhanTuGD[], tong, trangSo, co }   (tt = con|mat|moi; co ≤ 500, mặc định 100)
//  GET /api/ban-do/giao-dien-doi?nenTang=                   → DoiGD[] (mới nhất trước, ≤ 200)
//  GET /api/ban-do/giao-dien/:nenTang/tom-tat               → { van: string }  (văn bản gọn cho AI: trang → phần tử có nhận dạng bền)
//  GET /api/ban-do/thao-tac/:id  (đã có) → thêm phanTuDung: { trang: string; nhan: string; css: string | null; trangThai: TrangThaiPhanTuGD | "khong_thay" }[] và sucKhoe.giaoDienDoi?: boolean
